<template>
  <div>
    <div class="dp_text mt-4">
      Sélectionnez une plateforme et investir sur ce portefeuille
    </div>
    <div class="mt-4 mb-1">
      <select class="form-select mf_bg form-select-sm w-50" v-model="platform">
        <option disabled selected value="null">Secteur</option>
        <option
          v-for="(plat, index) in platforms"
          :key="index"
          :value="platform"
        >
          {{ plat.platform }}
        </option>
      </select>
    </div>
    <div class="mt-4">
      <b-button
        target="_blank"
        rel="noopener"
        class="btnValidation"
        style="display: inline-block"
        :href="'/first_portfolio/affiliation/' + platform.platform_contract"
      >
        <b-icon icon="check2-circle" aria-hidden="true" class="btnIcon" />
        <span class="btnText">Optez pour ce contrat</span></b-button
      >
    </div>
  </div>
</template>

<script>
export default {
  props: ["platforms", "token", "route"],
  data() {
    return {
      platform: this.platforms[0]
    };
  },

  mounted() {}
};
</script>